import { useMemo } from 'react'
import { Link } from '@router'
import type { Recipe } from '@hewey/shared'
import { buildCollections } from './collections.ts'
import { CollectionRow } from './CollectionRow.tsx'
import type { RecipeFilter } from './filter.ts'
import styles from './ExploreCollections.module.css'

type Props = {
	recipes: Recipe[]
	onSeeAll: (patch: Partial<RecipeFilter>) => void
}

// Explore's "zen" state: the suggested-collection rows, shown when there's no
// search query and no active filter. "See all" on a row hands its filter patch
// up to drop the user into the matching results grid.
export const ExploreCollections = ({ recipes, onSeeAll }: Props) => {
	const collections = useMemo(() => buildCollections(recipes), [recipes])

	return (
		<div className={styles.rows}>
			{collections.map((c) => {
				const patch = c.seeAll
				return (
					<CollectionRow
						key={c.key}
						title={c.title}
						subtitle={c.subtitle}
						recipes={c.recipes}
						onSeeAll={patch ? () => onSeeAll(patch) : undefined}
					/>
				)
			})}

			<Link href="/recipes/all" className={styles.viewAll}>
				View all recipes
			</Link>
		</div>
	)
}
